import { useRef, useState } from "react";
import { toast } from "sonner";
import { Mic, Square, Loader2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";

export const VoiceButton = ({ onText }) => {
  const [state, setState] = useState("idle");
  const rec = useRef(null);
  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      const chunks = [];
      mr.ondataavailable = (e) => e.data.size && chunks.push(e.data);
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        setState("busy");
        const type = mr.mimeType || "audio/webm";
        const fd = new FormData();
        fd.append("file", new Blob(chunks, { type }), `voice.${type.includes("mp4") ? "mp4" : "webm"}`);
        try {
          const { data } = await api.post("/sites/transcribe", fd);
          if (data.text) onText(data.text);
          else toast.info("We didn't catch that. Try again a little louder.");
        } catch (e) {
          toast.error(errMsg(e));
        }
        setState("idle");
      };
      mr.start();
      rec.current = mr;
      setState("rec");
    } catch {
      toast.error("Microphone not available. Allow mic access or type instead.");
    }
  };
  const stop = () => rec.current?.stop();
  return (
    <button type="button" onClick={state === "rec" ? stop : start} disabled={state === "busy"} data-testid="voice-record-btn"
      className={`relative flex h-14 w-14 shrink-0 items-center justify-center rounded-full text-white transition-transform hover:scale-105 ${state === "rec" ? "bg-red-500" : "bg-secondary"}`}
      aria-label={state === "rec" ? "Stop recording" : "Speak your idea"}>
      {state === "rec" && <span className="absolute inset-0 animate-ping rounded-full bg-red-400 opacity-60" />}
      {state === "busy" ? <Loader2 className="h-6 w-6 animate-spin" /> : state === "rec" ? <Square className="relative h-5 w-5" /> : <Mic className="h-6 w-6" />}
    </button>
  );
};
